
import {useHistory } from "react-router-dom";
import Header from './Header.js';
import Footer from './Footer.js';

function AboutUs() {

  
  return (
      <>
<Header/>
<div class="container-fluid" style={{marginTop: 120}}>
<div className="pl-4">
                      <h4 className="display-3 text-success" style={{fontSize: '25px', marginBottom: 20, fontWeight: 'bold'}}>Nigeria Youths' Empowerment 2021</h4>
                      
                      <p className="text-success paragraphStyles" style={{textAlign:'justify' }} >
                    Nigeria Youths Empowerment 2021 is a long term pre-existing insight of the Nigerian Empowerers' NGO. With the support of the United Nations and several Local and International Philantropists, it has been put to sail. This organisation has since its existence empowered not less than 700,000 Nigerian Youths.
                      </p>
                  

<p className="text-success paragraphStyles" style={{marginBottom: '290px', textAlign: 'justify'}}>  The future of Nigeria lies in the hands of the youths. Several Foreign and Local Philanthropists have seen this as well and in a bid to lift these youths out of poverty have decided to empower these youths. This goal is being set to reality through the Nigeria Youth Empowerers NGO.</p>
                     
                    </div>
                
</div>

<Footer/>

</>
  );
}

export default AboutUs;
